import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'
import LoggedSidebar from 'App/Shell/LoggedSidebar'
import { Alert } from 'loyal-react'
import { Form } from '.'
import Helmet from 'react-helmet'

import FormPlaceholder from './FormPlaceholder'

import ReactPlaceholder from 'react-placeholder'
import 'react-placeholder/lib/reactPlaceholder.css'

class Address extends Component {
  constructor (props) {
    super(props)

    this.state = {
      formReady: false
    }
  }

  componentDidMount () {
    this.props.zipCode &&
      this.props.fetchShipping(this.props.zipCode.value)

    this.props.participant && !this.props.participant.isLoading && !this.props.isLoading && setTimeout(() => {
      !this.state.formReady && this.setState({ formReady: true })
    }, 3000)
  }

  error = () => {
    if (this.props.participant.hasError) {
      return (
        <Alert
          isError
          title='Ops! Não foi possível salvar as suas informações.'
          description='Tente novamente mais tarde.'
          className='pb-2'
          onClose={this.props.closeAlert}
        />
      )
    }
    if (this.props.hasError) {
      return (
        <Alert
          isError
          title='Ops! Não foi possível buscar seu CEP.'
          description='Tente novamente mais tarde.'
          className='pb-2'
          onClose={this.props.closeAlert}
        />
      )
    }

    return ''
  }

  render () {
    return (
      <Fragment>
        <Helmet>
          <title>{`Meu endereço - ${process.env.REACT_APP_TITLE || ''}`}</title>
        </Helmet>
        <div className='container-fluid px-0 bg-ui-4'>
          <div className='container pl-2 pr-2 pt-0 pb-4 py-md-2 pt-md-3'>
            <div className='row'>
              <LoggedSidebar selected={this.props.location.pathname} count={0} />
              <div className='col-12 col-lg-8 mt-0'>
                <div className='row'>
                  {this.error()}
                  <div className='col-12 border-color-ui-3 bg-white border radius'>
                    <div className='checkout-step row px-1 py-2 border-bottom border-color-ui-3 '>
                      <div className='col mr-auto'>
                        <h2 className='txt-title txt-font-body txt-initial color-title mr-auto'>
                          Endereço
                        </h2>
                      </div>
                    </div>
                    <div className='row px-0 pb-2 pt-half border-bottom border-color-ui-3'>
                      <ReactPlaceholder
                        ready={this.state.formReady}
                        customPlaceholder={<FormPlaceholder />}
                      >
                        <Form {...this.props} />
                      </ReactPlaceholder>

                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Fragment>
    )
  }
}

const valueType = PropTypes.shape({
  value: PropTypes.string,
  disabled: PropTypes.string
})

Address.propTypes = {
  location: PropTypes.shape({ pathname: PropTypes.string.isRequired })
    .isRequired,
  isLoading: PropTypes.bool.isRequired,
  hasError: PropTypes.bool.isRequired,
  street: valueType,
  streetType: valueType,
  district: valueType,
  city: valueType,
  state: valueType,
  zipCode: valueType,
  fetchShipping: PropTypes.func,
  updateAddress: PropTypes.func,
  participant: PropTypes.object,
  closeAlert: PropTypes.func.isRequired
}

export default Address



// WEBPACK FOOTER //
// ./src/Participant/Address/Address.js